import { ApiResponse } from "../types";

export async function getHostagesActivities(id:string | undefined) {
  console.log('fetch Activities for: ', id);
  if (!id) {
    console.log("Error - getHostagesActivities - No id provided");
    return;
  }
  try {
    const response = await fetch(`/api/activity/byHostage/${id}`, {
      method: "GET",
      credentials: "include",
    });
    return await response.json();
  } catch (err) {
    console.error("[getHostagesActivities] - Error fetching data:", err);
  }
}

export async function fetchHostages() {
  try {
    const response = await fetch("/api/hostage", {
      method: "GET",
      credentials: "include",
    });
    const res = (await response.json()) as ApiResponse;
    return res;
  } catch (err) {
    console.error("Error fetching data:", err);
  }
};

export async function fetchHostageStories(id: string | undefined) {
  console.log('fetch stories for: ', id);
  if (!id) {
    console.log("Error - fetchHostageStories - No id provided");
    return;
  }
  try {
    const response = await fetch(`/api/story/byHostage/${id}`, {
      method: "GET",
      credentials: "include",
    });
    return await response.json();
  } catch (err) {
    console.error("[fetchHostageStories] -Error fetching data:", err);
  }
}

export async function fetchHostageLetters(id: string | undefined) {
  console.log('fetch stories for: ', id);
  if (!id) {
    console.log("Error - fetchHostageLetters - No id provided");
    return;
  }
  try {
    const response = await fetch(`/api/letter/byHostage/${id}`, {
      method: "GET",
      credentials: "include",
    });
    return await response.json();
  } catch (err) {
    console.error("[fetchHostageLetters] -Error fetching data:", err);
  }
}



export function fetchHostageData(id: string | undefined) {
  if (!id) {
    console.log("Error - fetchHostageData - No id provided");
    return;
  }
  return fetch(`/api/hostage/${id}`, {
    credentials: "include", // include cookies in the request
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(res => ({
      hostageData: res.data,
      userData: res.user,
    }))
    .catch(err => {
      console.error("[fetchHostageData] - Error fetching hostage data:", err);
      throw err; // Pass the error to be handled in the calling component
    });
}
